module.exports = __webpack_public_path__ + "img/empty1.f91447b9.png";